export const getList = state => state.list;
export const getTypes = state => state.types;
export const getMetaCommon = state => state.metaCommon;
export const getDocument = state => state.document;
export const getComments = state => state.comments;
export const getSharedDocument = state => state.sharedDocument;
export const getUnlockSharedDocument = state => state.unlockSharedDocument;
export const getDraftDocuments = state => state.draftDocuments;
export const getCategories = state => state.categories;
export const getDraftDocumentItem = state => state.draftDocumentItem;
